export enum CheckoutTypes {
    CVFormats = 1,
    PremierAccounts = 2,
    CVQuota = 3,
    AdPromotions = 4,
    CVClinic = 5,
    Invoice = 6
}